const I18_LNG = 'I18_LNG';

export const localStorageServices = {
  setI18Lng: (data: string) => {
    const json = JSON.stringify(data);
    localStorage.setItem(I18_LNG, json);
  },
  getI18Lng: () => {
    if (localStorage.getItem(I18_LNG)) {
      const json = localStorage.getItem(I18_LNG);
      if (json) {
        return JSON.parse(json);
      }
    } else {
      return 'ko';
    }
  },
  removeI18Lng: () => {
    localStorage.removeItem(I18_LNG);
  },
};
